<template>
  <div v-loading="loading">
    <div class="title">我的学员</div>
    <el-select
      class="mb-12 mr-12 w-90"
      v-model="searchState"
      size="medium"
      placeholder="状态"
      clearable
    >
      <el-option label="未开启" :value="1"></el-option>
      <el-option label="进行中" :value="2"></el-option>
      <el-option label="已结束" :value="3"></el-option>
    </el-select>
    <el-input
      class="mb-12 mr-12 w-200"
      placeholder="学员姓名 / 用户名"
      prefix-icon="el-icon-search"
      v-model="searchStudent"
      size="medium"
      clearable
    >
    </el-input>
    <el-button type="primary" size="medium" plain @click="search"
      >查询</el-button
    >
    <el-button size="medium" @click="clearSearch">重置</el-button>
    <el-table :data="studentList" :stripe="true">
      <el-table-column label="学员姓名">
        <template slot-scope="scope">
          <span v-if="scope.row.student.realname">{{
            scope.row.student.realname
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="用户名" prop="student.name"></el-table-column>
      <el-table-column label="导员">
        <template slot-scope="scope">
          <span v-if="scope.row.guider">{{ scope.row.guider.realname }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="导师">
        <template slot-scope="scope">
          <span v-if="scope.row.mentor">{{ scope.row.mentor.realname }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status_label"></el-table-column>
      <el-table-column label="开启时间">
        <template slot-scope="scope">
          <span v-if="scope.row.start_at">{{ scope.row.start_at }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="任务开放"
        prop="open_tasks_statistics"
      ></el-table-column>
      <el-table-column
        label="任务完成"
        prop="finished_tasks_statistics"
      ></el-table-column>
      <el-table-column
        v-if="
          authPermissions.includes(
            'gongfu.api.fuwu_admin.study_paths.status.update'
          ) ||
            authPermissions.includes('gongfu.api.fuwu_admin.study_paths.show')
        "
        width="110"
        label="操作"
      >
        <template slot-scope="scope">
          <span
            v-if="
              authPermissions.includes(
                'gongfu.api.fuwu_admin.study_paths.status.update'
              )
            "
          >
            <span v-if="scope.row.status !== 1" class="info-color">已开启</span>
            <el-link
              v-else
              type="primary"
              :underline="false"
              @click="openPath(scope.row.id)"
              >开启</el-link
            >
          </span>
          <el-divider
            v-if="
              authPermissions.includes(
                'gongfu.api.fuwu_admin.study_paths.status.update'
              ) &&
                authPermissions.includes(
                  'gongfu.api.fuwu_admin.study_paths.show'
                )
            "
            direction="vertical"
          ></el-divider>
          <el-link
            v-if="
              authPermissions.includes('gongfu.api.fuwu_admin.study_paths.show')
            "
            type="primary"
            :underline="false"
            @click="goPathDetail(scope.row.id)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="getData"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import studentService from "@/global/service/student";

export default {
  data() {
    return {
      loading: true,
      searchState: null,
      searchStudent: null,
      studentList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
        status: this.searchState,
        student_search: this.searchStudent
      };
      this.loading = true;
      studentService
        .list(params)
        .then(res => {
          this.studentList = res.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openPath(id) {
      studentService.stateChange(id, { status: 2 }).then(() => {
        this.getData();
        this.$message.success("开启成功");
      });
    },
    goPathDetail(id) {
      this.$router.push({
        name: "StudentDetail",
        params: { id }
      });
    },
    search() {
      this.pagination.currentPage = 1;
      this.getData();
    },
    clearSearch() {
      this.searchState = null;
      this.searchStudent = null;
      this.pagination.currentPage = 1;
      this.getData();
    }
  }
};
</script>
